// Sản phẩm/ dịch vụ
export const GET_LIST_PRODUCT_INVOICE = "GET_LIST_PRODUCT_INVOICE";
export const GET_LIST_PRODUCT_INVOICE_SUCCESS =
  "GET_LIST_PRODUCT_INVOICE_SUCCESS";
export const GET_LIST_PRODUCT_INVOICE_FAIL = "GET_LIST_PRODUCT_INVOICE_FAIL";
export const RESET_LIST_PRODUCT_INVOICE = "RESET_LIST_PRODUCT_INVOICE";

// Chi tiết Sản phẩm/ dịch vụ
export const GET_DETAIL_PRODUCT_INVOICE = "GET_DETAIL_PRODUCT_INVOICE";
export const GET_DETAIL_PRODUCT_INVOICE_SUCCESS =
  "GET_DETAIL_PRODUCT_INVOICE_SUCCESS";
export const GET_DETAIL_PRODUCT_INVOICE_FAIL =
  "GET_DETAIL_PRODUCT_INVOICE_FAIL";
export const RESET_DETAIL_PRODUCT_INVOICE = "RESET_DETAIL_PRODUCT_INVOICE";

// Tạo Sản phẩm/ dịch vụ
export const CREATE_PRODUCT_INVOICE = "CREATE_PRODUCT_INVOICE";
export const CREATE_PRODUCT_INVOICE_SUCCESS = "CREATE_PRODUCT_INVOICE_SUCCESS";
export const CREATE_PRODUCT_INVOICE_FAIL = "CREATE_PRODUCT_INVOICE_FAIL";
export const RESET_CREATE_PRODUCT_INVOICE = "RESET_CREATE_PRODUCT_INVOICE";

// Tạo lsit Sản phẩm/ dịch vụ
export const CREATE_LIST_PRODUCT_INVOICE = "CREATE_LIST_PRODUCT_INVOICE";
export const CREATE_LIST_PRODUCT_INVOICE_SUCCESS =
  "CREATE_LIST_PRODUCT_INVOICE_SUCCESS";
export const CREATE_LIST_PRODUCT_INVOICE_FAIL =
  "CREATE_LIST_PRODUCT_INVOICE_FAIL";
export const RESET_CREATE_LIST_PRODUCT_INVOICE =
  "RESET_CREATE_LIST_PRODUCT_INVOICE";

// EDIT Sản phẩm/ dịch vụ
export const EDIT_PRODUCT_INVOICE = "EDIT_PRODUCT_INVOICE";
export const EDIT_PRODUCT_INVOICE_SUCCESS = "EDIT_PRODUCT_INVOICE_SUCCESS";
export const EDIT_PRODUCT_INVOICE_FAIL = "EDIT_PRODUCT_INVOICE_FAIL";
export const RESET_EDIT_PRODUCT_INVOICE = "RESET_EDIT_PRODUCT_INVOICE";

// delete Sản phẩm/ dịch vụ
export const DELETE_PRODUCT_INVOICE = "DELETE_PRODUCT_INVOICE";
export const DELETE_PRODUCT_INVOICE_SUCCESS = "DELETE_PRODUCT_INVOICE_SUCCESS";
export const DELETE_PRODUCT_INVOICE_FAIL = "DELETE_PRODUCT_INVOICE_FAIL";
export const RESET_DELETE_PRODUCT_INVOICE = "RESET_DELETE_PRODUCT_INVOICE";

// Get list tsuat
export const GET_LIST_VAT = "GET_LIST_VAT";
export const GET_LIST_VAT_SUCCESS = "GET_LIST_VAT_SUCCESS";
export const GET_LIST_VAT_FAIL = "GET_LIST_VAT_FAIL";
export const RESET_GET_LIST_VAT = "RESET_GET_LIST_VAT";

// GET_ALL_PRODUCT_INVOICE
export const GET_ALL_PRODUCT_INVOICE = "GET_ALL_PRODUCT_INVOICE";
export const GET_ALL_PRODUCT_INVOICE_SUCCESS =
  "GET_ALL_PRODUCT_INVOICE_SUCCESS";
export const GET_ALL_PRODUCT_INVOICE_FAIL = "GET_ALL_PRODUCT_INVOICE_FAIL";
export const RESET_GET_ALL_PRODUCT_INVOICE = "RESET_GET_ALL_PRODUCT_INVOICE";

//
export const SET_COLUMN_VISIBLE_PRODUCT_INVOICE =
  "SET_COLUMN_VISIBLE_PRODUCT_INVOICE";
